// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__nQKFd","card":"_styles_card__B0F+z","card_info":"_styles_card_info__ae5ht","card_btn":"_styles_card_btn__jmBz7"};